<template>
    <div class=" fixed-bottom">
        <!-- <p class="mrg4 fixed-bottom"> Copyright @ 2022 <a href="www.rentalect.com" > www.rentalect.com.</a> All Rights Reserved.</p> -->
        <div class="card-footer text-muted text-center color3">
           <span class="mrg4">Copyright @ 2022 <a class="link1">www.evenware.com </a>All Rights Reserved.</span> 
        </div>


    </div>
    
</template>
<script>
   

</script>
<style>
    .mrg4 {
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: 5px;
        font-size: 15px;
      }
      
      .link1{
        color: blue;
        cursor: pointer;
      }
     .color3{
      background-color: #E9E9E3;
     }
     
      
      
    
</style>